var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 64,
    viewBox: "0 0 57 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0714 1H38.5858L56 18.4142V59.9375C56 61.6273 54.6262 63 52.9286 63H4.0714C2.37381 63 1 61.6273 1 59.9375V4.06246C1 2.3727 2.37399 1 4.0714 1Z",
    fill: "white",
    stroke: "#3537E5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 18H43.0129C40.7977 18 39 16.2041 39 13.9911V0L57 18Z",
    fill: "#2A2CD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.42e099f5bfa4fcd530bafbcec2160e4d.svg";
export { ForwardRef as ReactComponent };